import { Administration } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IAdministrationList } from "./list.gen.d";
import { type Pagination, type Query } from "../../base_classes/dto_list.d";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class AdministrationList extends DtoList implements IAdministrationList {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/administration";
  _kind = "Administration";
  _name = "administration";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: Administration[] = [];
  queriedList: Administration[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): Administration {
    return new Administration([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>
  ): Promise<Administration[]> {
    return (await super.getAll(pathVars)) as Administration[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination
  ): Promise<{
    items: Administration[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: Administration[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination
  ): Promise<Administration[]> {
    return (await super.query(queries, pagination)) as Administration[];
  }

  override async search(
    query: string,
    pagination?: Pagination
  ): Promise<Administration[]> {
    return (await super.search(query, pagination)) as Administration[];
  }
}
